module.exports = {
  APPLICATION_ID: "hFTdUeyVQg33XWLinEiaCC1NbgavmegAeJL9ezyz",
  JAVASCRIPT_KEY: "vv2hbNrfcK9kZCWmwvXO32lw4PxKk9ddIsMUEciJ",
  SERVER_URL: "https://parcodeicolli.b4a.io",
  API_URL: "https://parcodeicolli-api-dev.2caffe.it",
};
